import { useMediaQuery } from '@withjoy/joykit/utils';

export const useResizeAlohaTitle = (title: string) => {
  const isMobile = useMediaQuery(theme => theme.mediaQueries.between(0, { breakpointAlias: 'sm2' }));
  const isTablet = useMediaQuery(theme => theme.mediaQueries.between({ breakpointAlias: 'sm2' }, { breakpointAlias: 'sm4' }));
  const isNarrowDesktop = useMediaQuery(theme => theme.mediaQueries.between({ breakpointAlias: 'sm4' }, 1291));
  const isCharCountLimitExceeded = title && title.length > 13;
  const handleFontSizeDescrease = () => {
    if (isCharCountLimitExceeded) {
      if (isNarrowDesktop) {
        return '1.75rem';
      } else if (isTablet) {
        return '2.75rem';
      } else if (isMobile) {
        return '1.75rem';
      }
      return '2.5rem';
    }
    return '3rem';
  };
  const descreasedSize = handleFontSizeDescrease();
  return descreasedSize;
};
